import React, { FC } from 'react';

import Layout, { Head, Section, Logo } from 'components/Layout';

import { Text, Button } from 'components/UI';

import styles from './errorPage.module.scss';

const pageTexts = {
  404: 'Sorry, we can’t find the page you were looking for.',
  500: 'Sorry, something went wrong.',
};

interface IProps {
  code: '404' | '500';
}

const ErrorPage: FC<IProps> = ({
  code,
}) => (
  <Layout appearance="plain">
    <Head title={`Error ${code}`} />
    <Section
      isCentered
      className={styles.container}
      wrapperClassName={styles.wrapper}
    >
      <Logo className={styles.logo} />
      <Text
        category="h1"
        className={styles.title}
      >
        <span>Error  </span>
        <em>{code}</em>
      </Text>
      <Text className={styles.text}>{pageTexts[code]}</Text>
      <Button
        isFixedWidth
        link="/"
        className={styles.button}
      >
        Home Page
      </Button>
    </Section>
  </Layout>
);

export default ErrorPage;
